<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.curriculum.header.label.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <!-- Form row -->
                    <div class="row" v-if="data._id">
                        <div class="col-md-12">
                            <div class="card-box">
                                <form>
                                    <!-- <div v-if="data._id" class="form-row" >
                                        <div class="form-group col-md-3">
                                            <label  for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                    </div> -->

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.trucker.firstName" readonly class="form-control" >
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.lastname')}}
                                            </label>
                                            <input type="text" v-model="data.trucker.lastName" readonly class="form-control" >
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <!--<div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.email')}}
                                            </label>
                                            <input type="text" v-model="data.trucker.email" readonly class="form-control" >
                                        </div>-->
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.phone')}}
                                            </label>
                                            <input type="text" v-model="data.trucker.primaryPhone" class="form-control" readonly  v-mask="['(##) ####-####', '(##) #####-####']">
                                        </div>
                                    </div>
 
                                    <div class="form-row">
                                         <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.curriculum.label.expirience')}}
                                            </label>
                                            <textarea disabled style="height:200px;" type="text" v-model="data.expirience" class="form-control"></textarea>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.curriculum.label.expirience.additional')}}
                                            </label>
                                            <textarea disabled style="height:200px;" type="text" v-model="data.expirienceAditional" class="form-control"></textarea>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.curriculum.label.category.cnh')}}
                                            </label>
                                            <input type="text" :value="$t(data.cnhCategory)" readonly class="form-control">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.curriculum.label.course.type')}}
                                            </label>
                                            <input type="text" :value="$t(data.additionalCourse)" readonly class="form-control">
                                        </div>
                                    </div>
                                     
                                </form>
                                <br>
                                <div class="d-flex justify-content-between bd-highlight mb-3">
                                    <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive"/>
    </div>
</template>

<script>
import List from './ListCurriculum';
import Controller from './CrtCurriculum';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';

let maxDate = new Date();
maxDate.setMonth(maxDate.getMonth() + 3);

export default {
  name: 'Curriculum',
  components: {
    Spinner,
    Toast,
    List,
    Confirmation
  },
  data() {
      return {
        errors: [],
         disabledDates: {
            to: new Date(), // Disable all dates up to specific date,
            from: maxDate, // Disable all dates after specific date
        },
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        companies:[],
        data: {
            expirienceAditional: null,
            expirience: null,
            cnhCategory: null,
            additionalCourse: null,
            trucker:{
                firstName: null,
                lastName: null,
                email: null,
                primaryPhone: null,
            }
        }
    }
  },
  methods: Controller.methods,
  created() {
         Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
